import { Howl, Howler } from 'howler/dist/howler.js';

// fixes chrome52 bug! https://github.com/goldfire/howler.js/issues/593#issuecomment-240029932
Howler.autoSuspend = false;
const fadeTimeout = 1000;

export default function playSoundWithHowler(soundUrl, playCount, soundPlayTimeout, done) {
	let sound;
	try {
		sound = new Howl({
			src: [soundUrl],
			onplay: () => {
				log('Audio playing from executor');
	
				clearTimeout(soundPlayTimeout);
			},
			onend: () => {
				log('Audio from executor ended');
	
				clearTimeout(soundPlayTimeout);
			},
			onplayerror: (id, code) => {
				log(`Audio test error ${id}, code: ${code}`);
			},
		});
	
		const play = (times) => {
			if (times > 0) {
				sound.once('end', () => {
					times > 1 ? play(times - 1) : done?.();
				});
			}
			sound.play();
		};
	
		play(playCount);
	} catch (ex) {
		log('Error playing sound by Howler', ex);
		Screen.logErrorToSentry(ex);
		done?.();
		return;
	}

	return () => {
		sound.off();
		sound.fade(1.0, 0, fadeTimeout);
		done?.();
	};
}
